(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/tab-view/assets/javascripts/tab-view.js') >= 0) return;  svs.modules.push('/components/app/tab-view/assets/javascripts/tab-view.js'); 
var svs = svs || {};

(function(_, svs) {
  'use strict';


  svs = svs || {};
  svs.app = svs.app || {};
  svs.app.tab_view = svs.app.tab_view || {};

  svs.app.tab_view.resizeCurrentSlide = function() {
    if (this.$el) {
      this.$el
        .find('.rsOverflow')
        .height(this.$el.find('.rsActiveSlide').height());
    }
  };

  var log = new svs.core.log.Logger('svs.app.tab_view.TabView');

  svs.app.tab_view.TabView = Marionette.View.extend({
    currentView: null,

    currentLoader: null,

    initialize: function(options) {
      this.options = options;
      log.debug('Initializing.');

      var self = this;
      var cssClass = this.options.cssClass || '';

      $(window.document).on('resizeTabView', function() {
        self.resize();
      });

      $(window.document).on('removeTab', function(event, tabUrl) {
        self.removeTab(tabUrl);
      });

      if (!svs.core.detect.formfactor.mobile()) {
        this.swiper = new svs.components.Swiper();
      }

      this.path = this.options.path;

      var startTab = this.options.selected ?
        this.getTabIndexByUrl(this.options.selected) :
        0;

      var userSpecifiedPathInvalid = startTab < 0;

      if (userSpecifiedPathInvalid || !this.options.selected) {
        startTab = this.options.defaultTab ?
          this.getTabIndexByUrl(this.options.defaultTab) :
          0;
      }

      this.$el.addClass('royalSlider ' + cssClass);

      var htmlString;
      _.each(this.options.tabs, function(object, index) {
        object.index = index;
        htmlString = '';
        var view;

        if (object.caption) {
          view = object.view;

          if (object.href !== undefined) {
            htmlString =
              '<a href="' +
              object.href +
              '" class="rsTmb" onclick="event.preventDefault ? event.preventDefault() : event.returnValue = false;">' +
              object.caption +
              '</a>';
          } else {
            htmlString = '<span class="rsTmb">' + object.caption + '</span>';
          }
        } else {
          view = object;
        }

        if (view) {
          object.el = view.render().el;
          if (typeof view.triggerMethod === 'function') {
            view.triggerMethod('attach');
          }
        } else {
          object.el = $('<div/>');
        }
        var slideClass = object.cssClass || '';
        if (slideClass === '' && cssClass.indexOf('rsInverted') >= 0) {
          slideClass = 'slide-inverted';
        }
        self.$el.append($('<div/>')
          .addClass(slideClass)
          .append(htmlString)
          .append(object.el));
      });
      var sliderOptions = {
        addActiveClass: true,
        arrowsNav: false,
        navigateByClick: false,
        controlNavigation: 'thumbnails',
        minSlideOffset: 75,
        startSlideId: startTab,
        slidesSpacing: 0,
        transitionSpeed: 200,
        fadeinLoadedSlide: false,
        thumbs: {
          spacing: 30,
          transitionSpeed: 200
        },
        autoHeight: true
      };

      if (this.options.sliderOptions) {
        $.extend(sliderOptions, this.options.sliderOptions);
      }

      this.slider = this.$el.royalSlider(sliderOptions).data('royalSlider');

      this.$el.prepend(this.$el.find('.rsNav'));

      this.previousSlideId =
        sliderOptions.startSlideId &&
          this.slider.numSlides !== sliderOptions.startSlideId ?
          sliderOptions.startSlideId :
          0;

      this.slider.ev.on('rsAfterSlideChange', function(event) {
        var currentSlideId = event.target.currSlideId;

        if (currentSlideId !== self.previousSlideId) {
          if (self.options.tabs[self.previousSlideId].view) {
            self.options.tabs[self.previousSlideId].view.trigger('royalSliderSlideHidden');
          }
          var currentTab = self.options.tabs[currentSlideId];
          if (currentTab.viewClass && !currentTab.view) {
            var isInverted = cssClass.indexOf('rsInverted') >= 0;

            self.setDefaultHTML($(currentTab.el), isInverted);
          }

          if (currentTab.view) {
            currentTab.view.trigger('royalSliderSlideShown');
          }

          self.trigger('onChange', {
            currentView: currentTab,
            previousView: self.options.tabs[self.previousSlideId]
          });

          self.previousSlideId = currentSlideId;
        }
      });
      if (!this.options.noDetectActiveTab) {
        this.slider.ev.on(
          'rsOnUpdateNav',
          function() {
            this.detectActiveTab(this.$el.find('.rsSlide'));
          }.bind(this)
        );
      }

      if (!this.options.noAutoResizeSlides) {
        this.slider.ev.on('rsAfterContentSet', function(e, slideObject) {
          self.resizeSlides($(slideObject.holder));
        });
      }

      this.listenTo(this, 'onChange', this.slideChange);
      this.goToSlide(startTab);
      if (userSpecifiedPathInvalid) {
        this.updateUrl(this.getTab(startTab).id);
      }

      this.slider.ev.on('rsMaybeSizeReady', function() {
        self.resize();
      });

    },

    resizeSlides: function(slides) {
      var actionBar = $('#actionbar-content');
      var isActionBarVisible = actionBar.is(':visible');
      var betslip = $('#betslip-footer');
      var betslipRealHeight =
          betslip.length > 0 && betslip.is(':visible') ? betslip.height() : 0;
      var betslipHeight = svs.core.detect.formfactor.mobile() ?
          betslipRealHeight :
          0;
      var header = $('.header');
      var headerHeight = header.length > 0 ? header.outerHeight() : 0;
      var firstSlide = slides.first();
      var self = this;
      var isInModal = firstSlide.parents('.js-modal-container').length > 0;
      var visibleArea =
          firstSlide.length > 0 ?
            $(window).innerHeight() -
            (firstSlide.offset().top - this.$el.offset().top) -
            betslipHeight -
            headerHeight :
            $(window).innerHeight();
      var swiperOptions = {
        scrollbars: false,
        scrollingX: false,
        scrollingY: true
      };

      if (
        this.options.excludeActionBarHeight &&
        svs.core.detect.formfactor.mobile()
      ) {
        visibleArea -= isActionBarVisible ? actionBar.outerHeight(true) : 0;
        visibleArea += betslip.is(':visible') && isActionBarVisible ? 5 : 0; 
      }

      if (this.options.excludeHeight) {
        visibleArea -= this.options.excludeHeight;
      }

      slides.each(function() {
        var $this = $(this);
        $this.css('min-height', '0px');
        $this.children('.slide-inverted').css('min-height', '0px');
      });

      slides.each(function() {
        var $this = $(this);
        var offsetTop = Math.ceil($this.offset().top);
        var windowHeight = $(window).height();
        var minHeight =
            $this.outerHeight() > visibleArea ?
              $this.outerHeight() :
              visibleArea;
        if (!svs.core.detect.formfactor.mobile()) {
          var height = windowHeight - offsetTop;
          height = isInModal ? 'auto' : height;

          if (!self.options.doNotSetHeight) {
            $this.css('height', height);
          }
          minHeight = height;

          if ($this.hasClass('rsActiveSlide')) {
            self.swiper.init(this, swiperOptions);
          } else {
            $this
              .find('.js-swiper-container')
              .children(':first')
              .unwrap();
          }
        }
        $this.css('min-height', minHeight);

        $this.children('.slide-inverted').css('min-height', minHeight);
      });
      setTimeout(function() {
        self.trigger('sizeUpdated');
      }, 10);
    },

    updateUrl: function(id) {
      if (this.path && Object.prototype.hasOwnProperty.call(Backbone.history, 'fragment')) {
        var path = this.makePath(Backbone.history.fragment, id);
        log.debug('Updating url:', path);
        Backbone.history.navigate(path, { trigger: false, replace: true });
      }
    },

    setDefaultHTML: function(element, isInverted) {
      element.html('<div class="tab-view-loader"></div>');
      this.currentLoader = new svs.components.Loader(element.find('.tab-view-loader'));
      this.currentLoader.show(100, isInverted ? '' : 'inverted');
    },

    resize: function() {
      if (this.slider && this.slider.ev) {
        this.slider.ev.trigger('rsBeforeSizeSet');
        if (!this.options.noAutoResizeSlides) {
          this.resizeSlides(this.$el.find('.rsSlide'));
        }

        this.slider.updateSliderSize();
      }
    },

    detectActiveTab: function(eSlides) {
      var slides = eSlides;
      if (this.updClassTimeout) {
        clearTimeout(this.updClassTimeout);
      }
      this.updClassTimeout = setTimeout(
        function() {
          this.updClassTimeout = null;

          slides.each(function() {
            var $this = $(this);
            if ($this.hasClass('rsActiveSlide')) {
              $(window.document).trigger('resizeTabView');
              return false;
            }
          });
        }.bind(this),
        50
      );
    },

    onBeforeClose: function() {
      this.slider.ev.off('rsAfterContentSet');
      this.slider.ev.off();
      if (this.slider) {
        this.slider.destroy(true);
      }

      if (this.swiper) {
        this.swiper.dispose();
      }

      var slide = this.$el.find('.rsSlide');
      if (slide) {
        slide.remove();
        slide = null;
      }
    },

    slideChange: function(e) {
      log.debug('slideChange');
      this.updateUrl(e.currentView.id);
      this.goToSlide(e.currentView.index);
      this.trigger('currentSlideChange', e.currentView.id);
    },

    makePath: function(fragment, newId) {
      var path = this.endsWith(fragment, '/') ?
        fragment.substring(0, fragment.length - 1) :
        fragment;
      var query = '';

      if (path.indexOf('?') > 0) {
        query = path.substring(path.lastIndexOf('?'));
        path = path.substring(0, path.lastIndexOf('?'));
      }

      _.each(
        this.options.tabs,
        function(tab) {
          if (tab.id) {
            if (this.endsWith(path, tab.id)) {
              path = path.substring(0, path.length - tab.id.length);
            }
          }
        },
        this
      );

      if (!this.endsWith(path, '/')) {
        path += '/';
      }

      if (this.options.defaultTab !== newId) {
        path += newId;
      }

      if (query.length > 0) {
        path = this.endsWith(path, '/') ?
          path.substring(0, path.length - 1) :
          path;
        path += query;
      }
      return path;
    },

    endsWith: function(str, suffix) {
      return str.indexOf(suffix, str.length - suffix.length) !== -1;
    },

    goToSlide: function(tabIndex) {
      if (this.currentView) {
        var previousTab = this.getTab(this.currentView.tabIndex);
        var oldView = this.currentView;

        if (
          Object.prototype.hasOwnProperty.call(previousTab, 'viewClass') &&
          !this.options.cacheCreated
        ) {
          previousTab.el.html($('<div/>'));
          previousTab.view = null;

          window.requestIdleCallback(function() {
            if (_.isFunction(oldView.view.dispose)) {
              oldView.view.dispose();
            } else if (_.isFunction(oldView.view.destroy)) {
              oldView.view.destroy();
            }
          });
        }
      }

      var tab = this.getTab(tabIndex);
      if (Object.prototype.hasOwnProperty.call(tab, 'viewClass') && !tab.view) {
        this.pushView(tab.viewClass, tab.view, tab.params, tabIndex);
        if (Object.prototype.hasOwnProperty.call(this.options, 'router')) {
          this.options.router.navigate(this.options.statsUrl + tab.id, {
            trigger: false,
            replace: true
          });
        }
      }
    },

    getTab: function(tabIndex) {
      return tabIndex < this.options.tabs.length ?
        this.options.tabs[tabIndex] :
        {};
    },

    removeTab: function(tabUrl) {
      var index = this.getTabIndexByUrl(tabUrl);
      if (Boolean(index) || index === 0) {
        if (index > -1) {
          this.options.tabs.splice(index, 1);

          if (index < this.previousSlideId) {
            this.previousSlideId--;
          }

          if (index < this.startSlideId) {
            this.startSlideId--;
          }

          if (Boolean(this.slider) && Boolean(this.slider.slides)) {
            this.slider.removeSlide(index);
          }

          _.each(this.options.tabs, function(tab) {
            if (tab.index !== 0 && tab.index > index) {
              tab.index -= 1;
            }
          });
        }
      }
    },

    pushView: function(viewClass, view, params, tabIndex) {
      log.debug('pushView');

      var self = this;

      setTimeout(function() {
        if (!self.options) {
          return false;
        }

        if (viewClass && !view) {
          view = new viewClass({ params: params });
          self.options.tabs[tabIndex].view = view;
        }

        self.currentView = {
          tabIndex: tabIndex,
          view: view
        };

        if (self.currentLoader) {
          self.currentLoader.hide();
        }

        $(self.options.tabs[tabIndex].el).html(self.currentView.view.render(true).el);
      }, 0);

      this.resize();
    },

    getTabIndexByUrl: function(tabUrl) {
      if ((this.options || {}).tabs) {
        var selectedTab = _.find(this.options.tabs, function(tab) {
          return tab.id === tabUrl;
        });

        if (!selectedTab) {
          selectedTab = _.find(this.options.tabs, function(tab) {
            return (
              tab &&
              tab.caption &&
              tab.caption.toLowerCase() === (tabUrl && tabUrl.toLowerCase())
            );
          });
        }

        return _.indexOf(this.options.tabs, selectedTab);
      }
      return -1;
    },

    onClose: function() {
      if (this.slider && this.slider.ev) {
        this.slider.ev.off();
      }

      if (this.currentView) {
        if (_.isFunction(this.currentView.view.dispose)) {
          this.currentView.view.dispose();
        } else if (_.isFunction(this.currentView.view.destroy)) {
          this.currentView.view.destroy();
        }
      }

      this.destroyTabs();

      delete this.slider;

      delete this.options;
      delete this.$el;
      delete this.el;
    },

    destroyTabs: function() {
      if (this.options && this.options.tabs) {
        _.each(this.options.tabs, function(tab) {
          if (tab && tab.view && tab.view.destroy) {
            tab.view.destroy();
            tab.view = null;
          }
        });
      }

      if (this.options && this.options.tabs) {
        this.options.tabs = null;
        delete this.options.tabs;
      }
    }
  });
})(_, svs);

 })(window);